<script>
    import { onMount } from 'svelte';
    import { getWidthByScreenSize } from '$lib/components/_DisplayComponents/_utils/getWidthByScreenSize';

    export let content = {};
    export let transitionDelay = 0;
    export let transitionEffect = 'none';

    let Image;

    onMount(async () => {
        Image = (await import('$lib/components/_DisplayComponents/Image/Image.svelte')).default;
    });
</script>

<svelte:component
    this={Image}
    src={content.src}
    framed={content.framed}
    size={content.size}
    bgColor={content.box.backgroundColor}
    fixedMaxWidth={getWidthByScreenSize()}
    {transitionDelay}
    {transitionEffect}
/>
